import axios from '@tw/shared-ui-components/lib/utils/axios_interceptor';
import Router from "next/router";

export const fetchTutorialsData = (pageId) => {
  if (typeof window === "undefined") return;
  const baseURL = window.appConfig?.PDM_BFF_API || "http://localhost:3002";
  return axios.post(`/tutorial/${pageId}`, {}, { baseURL });
};

export const getVAda = async () => {
  try {
    if (typeof window === "undefined") return;

    const baseURL = window.appConfig?.PDM_BFF_API || "http://localhost:3002";
    // 開發環境不需要進行驗證直接調用 get-vada 接口
    if (window.appConfig?.NODE_ENV === "dev") {
      return axios.post(`${baseURL}/anon/get-vada`, {});
    }
    const response = await getReCaptchaScore();
    if (response?.status === 200) {
      if (response?.data?.success) {
        return axios.post(`${baseURL}/anon/get-vada`, {});
      } else {
        Router.push("/page-not-found");
      }
    } else {
      return axios.post(`${baseURL}/anon/get-vada`, {});
    }
  } catch (error) {
    console.log('getVAda >> catch', error);
  }
};

export const getReCaptchaScore = async () => {
  try {
    if (typeof window?.grecaptcha?.enterprise === "undefined") {
      console.error("reCAPTCHA 企业版脚本未加载");
      return null;
    }
    const baseURL = window.appConfig?.PURCHASE_BFF_API || "http://localhost:3001";
    const siteKey = window.appConfig?.NEXT_PUBLIC_RECAPTCHA_SITE_KEY;
    const action = "VisitorForm";
    // 使用 Promise 包装以确保正确等待异步操作完成
    return new Promise((resolve) => {
      grecaptcha.enterprise.ready(async () => {
        try {
          const token = await grecaptcha.enterprise.execute(siteKey, { action });
          const res = await axios.post(`${baseURL}/anon/common/verify-recaptcha`, {
            token,
            expectedAction: action
          });
          resolve(res);
        } catch (error) {
          console.log('getReCaptchaScore >> catch', error);
          resolve(null);
        }
      });
    });
  } catch (error) {
    console.log('getReCaptchaScore >> catch', error);
    return null;
  }
};